import {z} from 'zod';

export const ConnectionStatusSchema = z.enum(['config_needed', 'ready', 'broken']);
export type ConnectionStatus = z.infer<typeof ConnectionStatusSchema>;
